import { render } from "./custom-styles.vue?vue&type=template&id=1660b046"
import script from "./custom-styles.vue?vue&type=script&lang=js"
export * from "./custom-styles.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../opt/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__